import Layout from "../views/Layouts/DashboardLayout.vue";
import SystemInfo from "../views/Config/SystemInfo.vue";
import SystemConfig from "../views/Config/SystemConfig.vue";

export default {
  path: "/config",
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      path: "",
      redirect: "/config/sysinfo"
    },
    {
      path: "sysinfo",
      name: "System Information",
      component: SystemInfo
    },
    {
      path: "application",
      name: "System Configuration",
      component: SystemConfig
    },
  ]
};
